import defineCustomElement from '../../define-custom-element.js';

import TpCheckbox from './checkbox/tp-checkbox.js';
import TpSelectionCheckbox from './selection-boxes/tp-selection-checkbox.js';

import TpRadio from './radio/tp-radio.js';
import TpSelectionRadio from './selection-boxes/tp-selection-radio.js';

defineCustomElement('tp-checkbox', TpCheckbox);
defineCustomElement('tp-selection-checkbox', TpSelectionCheckbox);

defineCustomElement('tp-radio', TpRadio);
defineCustomElement('tp-selection-radio', TpSelectionRadio);

export {
  TpCheckbox,
  TpSelectionCheckbox,
  TpRadio,
  TpSelectionRadio
}
